import { create_div } from 'src/js/utils';
import './form_steps.scss';

jQuery(document).on('gform_post_render', function(event, form_id, current_page){
    new Form_Steps(form_id, current_page);
});

class Form_Steps {
    
    constructor(form_id, current_page){
        
        this.form = document.getElementById('gform_'+ form_id);

        if( !this.form ) return;
        
        if( this.form.form_steps_init ) return;
        this.form.form_steps_init = 1;

        this.container = this.form.closest('.ff_form_steps');
        if( !this.container ) return;

        this.current_page = parseInt(current_page);
        this.page = document.getElementById('gform_page_'+ form_id +'_'+ current_page);

        if( !this.page ) return;

        this.pages_count = this.form.querySelectorAll('.gform_page').length;
        this.footer = this.page.querySelector('.gform_page_footer');

        this.next_btn_init();
        this.back_btn_init();
        this.init_progress_count();
    }
    
    next_btn_init(){

        if( this.pages_count === this.current_page ) return;
        
        let btn = this.footer.querySelector('.next_button');
        if( !btn ) {
            btn = create_div('next_button nav_btn');
            this.footer.prepend(btn);
        }
        
        btn.addEventListener('click', ()=>{
            this.footer.querySelector('.gform_next_button').click();
        });
    }

    back_btn_init(){

        if( !this.enable_back_btn() ) return;
        if( this.current_page == 1 ) return; // disable on page 1
        
        let btn = this.footer.querySelector('.back_button');
        if( !btn ) {
            btn = create_div('back_button nav_btn');
            this.footer.prepend(btn);
        }

        btn.addEventListener('click', ()=>{
            this.footer.querySelector('.gform_previous_button').click();
        });
        
    }
    
    init_progress_count(){

        if( !this.enable_progress_count() ) return;

        if( this.footer.querySelector('.progress_indicator') ) return;
        
        let con = create_div('progress_indicator');
        this.footer.prepend(con);
        
        create_div('current', con, this.current_page);
        create_div('sep', con, '/');
        create_div('total', con, this.pages_count);
    }

    enable_back_btn(){
        if( !this.container.dataset.show_back_button ) return false;
        if( this.container.dataset.show_back_button === 'false' ) return false;
        return true;
    }

    enable_progress_count(){
        if( !this.container.dataset.show_progress_count ) return false;
        if( this.container.dataset.show_progress_count === 'false' ) return false;
        return true;
    }
}